export const LOGIN_ADMIN = "LOGIN_ADMIN";
export const GET_USERS = "GET_USERS";
export const GET_TEAMS = "GET_TEAMS";
export const GET_LIST_TEAM = "GET_LIST_TEAM";
export const GET_LIST_USER = "GET_LIST_USER";
export const GET_LIST_USER_TEAM = "GET_LIST_USER_TEAM";
export const GET_LIST_MANAGER = "GET_LIST_MANAGER";
export const GET_LIST_MOCKUP = "GET_LIST_MOCKUP";
export const GET_ALL_LOGS = "GET_ALL_LOGS";
export const GET_LIST_STORE = "GET_LIST_STORE";
export const GET_TEAM_DETAIL = "GET_TEAM_DETAIL";
export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_VARIANT_PRODUCTS = "GET_VARIANT_PRODUCTS";
export const TEAM_DELETE = "TEAM_DELETE";
export const GET_USER_DETAIL = "GET_USER_DETAIL";
export const GET_DESIGNS = "GET_DESIGNS";
export const GET_ORDERS_ETSY = "GET_ORDERS_ETSY";
export const GET_COLLECTIONS = "GET_COLLECTIONS";
export const GET_TEMPLATES = "GET_TEMPLATES";
export const GET_LIST_TAXONOMY = "GET_LIST_TAXONOMY";
export const GET_LIST_VARIANT_TAXONOMY = "GET_LIST_VARIANT_TAXONOMY";
export const GET_LIST_SHIPPING = "GET_LIST_SHIPPING";
export const AUTH_USER = "AUTH_USER";
export const SAVE_TEAM_ID = "SAVE_TEAM_ID";
export const SAVE_STORE_ID = "SAVE_STORE_ID";
export const SAVE_PAGE_INFO = "SAVE_PAGE_INFO";
export const SAVE_TYPE = "SAVE_TYPE";
export const SAVE_SHARED = "SAVE_SHARED";
export const SAVE_PRODUCT_VARIATIONS = "SAVE_PRODUCT_VARIATIONS";
export const UPDATE_LIST_VARIANT_TAXONOMY = "UPDATE_LIST_VARIANT_TAXONOMY";
export const UPDATE_OPTIONS = "UPDATE_OPTIONS";
export const GET_PRODUCT_PRINTIFY = "GET_PRODUCT_PRINTIFY";
export const GET_ALL_SUPPLIER_KEYS = "GET_ALL_SUPPLIER_KEYS";
export const GET_REPORT_DESIGN = "GET_REPORT_DESIGN";
export const GET_REPORT_PRODUCT = "GET_REPORT_PRODUCT";
export const GET_REPORT_MOCKUP = "GET_REPORT_MOCKUP";
export const GET_REPORT_ORDER = "GET_REPORT_ORDER";
export const GET_REPORT_ORDER_BY_DESIGNER = "GET_REPORT_ORDER_BY_DESIGNER";
export const GET_ALL_SUPPLIER_ACCOUNTS = "GET_ALL_SUPPLIER_ACCOUNTS";
export const GET_LIST_INFO = "GET_LIST_INFO";
export const GET_LIST_DATA_MERCH = "GET_LIST_DATA_MERCH";
export const GET_TOTAL_DATA_MERCH = "GET_TOTAL_DATA_MERCH"
export const GET_MERCH_DETAIL = "GET_MERCH_DETAIL"
export const GET_INFO_DETAIL = "GET_INFO_DETAIL"

